import { render, staticRenderFns } from "./ProductCaracteristics.vue?vue&type=template&id=03358800&"
import script from "./ProductCaracteristics.vue?vue&type=script&lang=js&"
export * from "./ProductCaracteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports